import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { Status } from '../../models/common/Status';
import { apiClientWithApi } from '../../utils/http';
import { ReasonTypes } from '../../hooks/components/useBlacklist/types';

export interface ReportState {
  status: Status;
}

export interface BlockRequest {
  useForInbound: boolean;
  useForOutbound: boolean;
  phone: string;
  reason?: ReasonTypes | null;
  comment?: string;
}

const initialState: ReportState = {
  status: {
    responseLoading: true,
    responseError: null,
    requestSuccess: null,
    requestError: null,
  },
};

export const addBlacklistNumber = createAsyncThunk(
  'Blacklist/addBlacklistNumber',
  async (request: BlockRequest, { rejectWithValue }) => {
    try {
      const response = await apiClientWithApi.post('blackphone', {
        ...request,
      });

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return rejectWithValue(error.message);
      } else return rejectWithValue('Не удалось заблокировать номер!');
    }
  },
);

export const blacklistPopupSlice = createSlice({
  name: 'popup',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(addBlacklistNumber.pending, (state) => {
        state.status.responseLoading = true;
        state.status.responseError = null;
        return state;
      })
      .addCase(addBlacklistNumber.fulfilled, (state, action) => {
        state.status.responseLoading = false;
        state.status.responseError = null;
        return state;
      })
      .addCase(addBlacklistNumber.rejected, (state) => {
        state.status.responseLoading = false;
        state.status.responseError = 'Не удалось заблокировать номер';
        return state;
      });
  },
});

export default blacklistPopupSlice.reducer;
